import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  private _currentLang: string;

  constructor() {
    // Inicializar con el idioma del navegador o el predeterminado
    this._currentLang = localStorage.getItem('language') || 
                       navigator.language.split('-')[0] || 
                       'es';
  }

  get currentLang(): string {
    return this._currentLang;
  }

  setLanguage(lang: string): void {
    this._currentLang = lang;
    localStorage.setItem('language', lang);
    // Aquí se podría recargar los recursos de traducción
  }
}
